<template>
  <div class="mob-remove-table-fixed image-list">
    <Modal v-model="pullImageModal" title="拉取镜像">
      <Form :model="pullImageForm" ref="pullImageForm" :rules="pullImageFormRules" :label-width="80">
        <FormItem label="节点" prop="node">
          <Select v-model="pullImageForm.node" placeholder="请选择镜像存放的节点">
            <Option v-for="item in nodesList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="Repository" prop="repository">
          <Input v-model="pullImageForm.repository" placeholder="如: nginx"/>
        </FormItem>
        <FormItem label="tag" prop="tag">
          <Input v-model="pullImageForm.tag" placeholder="默认: latest"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="pullImageSubmit" :loading="pullImageSubmitting">提交</Button>
        <Button @click="pullImageModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Row style="border-radius: 4px">
      <Col :md="nodeListSpan" v-show="nodeListShow">
        <Card>
          <nodeList ref="nodeList" v-on:nodeChange="init()"></nodeList>
        </Card>
      </Col>
      <Col :md="contentSpan" style="border-left: 16px solid #f5f7f9; border-right: 16px solid #f5f7f9;">
        <Card>
          <Row>
            <Col :sm="16">
              <span>
                <Button @click="nodeListShowBtn(false)" v-show="nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}" class="mob-hidden">
                  <Icon type="ios-arrow-back" />
                </Button>
                <Button @click="nodeListShowBtn(true)" v-show="!nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}">
                  <Icon type="ios-arrow-forward" />
                </Button>
              </span>
              <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="50" @submit.native.prevent>
              <FormItem label="镜像ID">
              <Input v-model="tableSearchForm.id" style="min-width: 200px" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
              </FormItem>
              </Form>
            </Col>
            <Col :sm="8" class="align-right" style="margin:0 0 8px 0">
              <Poptip
                :style="{marginRight: '8px'}"
                confirm
                transfer
                title="确定要移除吗？"
                @on-ok="batchRemove"
                ok-text="确认"
                cancel-text="取消"
                placement="bottom">
                <Button
                  :loading="batchRemoveSubmitting"
                  :disabled="!selected.length"
                  type="error"
                  icon="md-trash">批量移除</Button>
              </Poptip>
              <Button
                @click="pullImageModal = true"
                type="primary"
                icon="md-add">拉取镜像</Button>
            </Col>
          </Row>
          <Alert type="success" show-icon v-if="successMsg">{{ successMsg }}</Alert>
          <Alert type="error" show-icon v-if="errorMsg">{{ errorMsg }}</Alert>
          <Alert type="warning" show-icon v-if="not_conn.length">
            <span>连接失败的节点：</span>
            <span v-for="(item, index) in not_conn" :key="index">「{{ item }}」</span>
          </Alert>
          <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
          <Table
            v-else
            border
            highlight-row
            @on-selection-change="selectRow"
            :loading="tableLoading"
            ref="table"
            :data="table.data"
            :columns="table.columns"></Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: left;">
              当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
            </div>
            <div style="float: right;">
              <page
                :total="table.count"
                :current="table.page"
                :page-size="table.size"
                @on-change="getTableData"></page>
            </div>
          </div>
        </Card>
      </Col>
      <Col :md="pullTasksSpan">
        <Card>
          <ImagePullTasks ref="ImagePullTasks"></ImagePullTasks>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getAllNodes } from '@/api/container/node'
import { getImages, deleteImage, pullImage, batchDeleteImage } from '@/api/container/image'
import moment from 'moment'
import nodeList from '../components/node-list'
import ImagePullTasks from '../components/image-pull-tasks'

export default {
  name: 'list',
  components: {
    nodeList,
    ImagePullTasks
  },
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        id: ''
      },
      table: {
        data: [],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '镜像ID',
            key: 'Id',
            align: 'center',
            minWidth: 300
          },
          {
            title: '镜像名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.RepoTags) {
                if (params.row.RepoTags.length) {
                  return h('span', params.row.RepoTags[0].split(':')[0])
                }
              } else {
                return ''
              }
            }
          },
          {
            title: '标签',
            key: 'tag',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.RepoTags) {
                if (params.row.RepoTags.length) {
                  let RepoTags = params.row.RepoTags[0].split(':')
                  return h('span', RepoTags[1])
                }
              } else {
                return ''
              }
            }
          },
          {
            title: '节点',
            key: 'node_name',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '创建时间',
            key: 'Created',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.Created) {
                return h('span', moment(params.row.Created).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '虚拟容量',
            key: 'VirtualSize',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.VirtualSize) {
                if (params.row.VirtualSize > (1000 * 1000 * 1000)) {
                  return h('span', Math.round(params.row.VirtualSize / (1000 * 1000 * 1000)) + ' GB')
                } else if (params.row.VirtualSize > 1000 * 1000) {
                  return h('span', Math.round(params.row.VirtualSize / (1000 * 1000)) + ' MB')
                } else if (params.row.VirtualSize > 1000) {
                  return h('span', Math.round(params.row.VirtualSize / 1000) + ' KB')
                } else {
                  return h('span', params.row.VirtualSize + ' B')
                }
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 80,
            render: (h, params) => {
              return h('div', [
                // h('Button', {
                //   props: {
                //     type: 'info',
                //     size: 'small'
                //   },
                //   style: {
                //     marginRight: '5px'
                //   },
                //   on: {
                //     click: () => {
                //       // this.$router.push({name: 'container_node_detail', params: {id: params.row.id}})
                //     }
                //   }
                // }, '详情'),
                // h('Button', {
                //   props: {
                //     type: 'warning',
                //     size: 'small'
                //   },
                //   style: {
                //     marginRight: '5px'
                //   },
                //   on: {
                //     click: () => {
                //       // this.$router.push({name: 'container_node_edit', params: {id: params.row.id}})
                //     }
                //   }
                // }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要移除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.Id, params.row.node_id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '移除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      listError: false,
      not_conn: [],
      node_not_exists: [],
      moment: moment,
      nodeListSpan: 4,
      contentSpan: 16,
      pullTasksSpan: 4,
      nodesList: [],
      nodeListShow: true,
      pullImageModal: false,
      pullImageForm: {
        node: '',
        repository: '',
        tag: ''
      },
      pullImageFormRules: {
        node: {required: true, message: '请选择节点', trigger: 'change', type: 'number'},
        repository: {required: true, message: 'Repository是必填的', trigger: 'blur'}
      },
      pullImageSubmitting: false,
      selected: [],
      batchRemoveSubmitting: false,
      errorMsg: '',
      successMsg: ''
    }
  },
  created: function () {
    this.getNodes()
    this.init()
    this.nodeListShowBtn(true)
  },
  methods: {
    init () {
      this.getTableData()
      this.getTasks()
    },
    getTableData (value = 1) {
      this.table.page = value
      let reqData = {
        size: this.table.size,
        page: this.table.page,
        nodes: this.$refs.nodeList.selected
      }
      Object.assign(reqData, this.tableSearchForm)
      this.tableLoading = true
      this.selected = []
      getImages(reqData).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.not_conn = result.not_conn
        this.node_not_exists = result.node_not_exists
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        this.listError = true
        console.log(res.response)
      })
    },
    getTasks () {
      this.$refs.ImagePullTasks.getTasks(this.$refs.nodeList.selected)
    },
    clearSearchForm () {
      this.tableSearchForm = {
        id: ''
      }
    },
    nodeListShowBtn (status) {
      this.nodeListShow = status
      if (status) {
        if (this.screenWidth < 1025) {
          this.nodeListSpan = 8
          this.contentSpan = 16
          this.pullTasksSpan = 24
        } else {
          this.nodeListSpan = 4
          this.contentSpan = 16
          this.pullTasksSpan = 4
        }
      } else {
        this.nodeListSpan = 0
        this.contentSpan = 21
        this.pullTasksSpan = 3
      }
    },
    delete (id, nodeId) {
      deleteImage(id, nodeId).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    getNodes () {
      getAllNodes().then(res => {
        this.nodesList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    pullImageSubmit () {
      this.$refs.pullImageForm.validate((valid) => {
        if (valid) {
          this.pullImageSubmitting = true
          pullImage(this.pullImageForm).then(res => {
            this.pullImageSubmitting = false
            this.pullImageModal = false
            this.$Notice.success({title: '开始拉取，请等待'})
            this.init()
          }).catch(res => {
            this.pullImageSubmitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    selectRow () {
      this.selected = this.$refs.table.getSelection()
    },
    batchRemove () {
      this.batchRemoveSubmitting = true
      batchDeleteImage(this.selected).then(res => {
        this.getTableData(this.table.page)
        const result = res.data
        if (!result.error && !result.success) {
          this.errorMsg = result
        } else {
          this.errorMsg = result.error.length ? `移除失败：${result.error.join()}` : ''
          this.successMsg = result.success.length ? `移除成功：${result.success.join()}` : ''
        }
        this.batchRemoveSubmitting = false
      }).catch(res => {
        this.batchRemoveSubmitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        this.successMsg = ''
        this.errorMsg = res.response.data
      })
    }
  }
}
</script>

<style lang="less">
.image-list{
  .ivu-col-span-md-4 .ivu-card-bordered .ivu-card-body>div {
    padding: 0!important;
  }
  .ivu-row>div:nth-child(2){
    // border-left: 0!important;
    // border-right: 0!important;
    // margin-top:10px;
  }
  @media screen and (max-width:1280px){
    .ivu-col-span-sm-8,.ivu-col-span-sm-12{
      width:100%;
    }
  }
}

</style>
